import { withApiBase } from "./base";

export async function searchCities({ countryCode, q }) {
  const url = withApiBase(
    `/geo/cities?country=${encodeURIComponent(countryCode)}&q=${encodeURIComponent(q)}`
  );

  const res = await fetch(url);
  if (!res.ok) throw new Error(`geo/cities failed: ${res.status}`);
  return await res.json();
}
